export const sleep = ms => new Promise(resolve => global.setTimeout(resolve, ms))

export const frames = () => new Promise(resolve => global.requestAnimationFrame(resolve))

export const sequentially = async (items, callback) => {
    const results = []

    await items.reduce(async (previousPromise, value, index) => {
        await previousPromise

        const promise = callback(value, index)
        const result = await promise
        results.push(result)

        return promise
    }, Promise.resolve())

    return results
}

export const retry = async (callback, options = {}) => {
    let {
        every = 1000,
        timeout = 10000
    } = options ?? {}

    let retries = 0

    return new Promise((resolve, reject) => {
        const interval = global.setInterval(() => {
            const result = callback()

            if(result) {
                global.clearInterval(interval)
                resolve(result)
            } else if((++retries * every) >= timeout) {
                global.clearInterval(interval)
                reject()
            }
        }, every)
    })
}